import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import _ from 'lodash';
import validate from 'validate.js';
import 'react-select/dist/react-select.css';
import branches from '../../data/branches-std-only';
import {confirmAccount} from '../../actions/product';
import {newAccountOpeningRoutes} from '../../routers/routes';
import {clearBolProfileOperators, fetchBolOperators, fetchBolProfiles} from '../../actions/bol';
import ButtonsComponent from '../ButtonsComponent';
import FormField from '../formField/FormField';
import {Glyphicon, OverlayTrigger, Tooltip} from 'react-bootstrap';
import {BolSetup} from './bol-setup';

const STATEMENTS_DELIVERY_METHODS = {
    email: 'E',
    post: 'M',
    suppressStatement: 'S',
};
const FREQUENCY = {
    monthly: 'Monthly',
    weekly: 'Weekly',
    daily: 'Daily'
};

export const ADDITIONAL_PRODUCTS = {
    bolId: 'Business Online',
    cashManId: 'Cash Management'
};

export const OTHER_PROFILE_ID = {value: 'otherId', label: 'Other'};

const accountDetails = {
    //branchCode: 'Rosebank',
    preferences: {
        statementDeliveryFrequency: FREQUENCY.monthly,
        statementDeliveryMethod: STATEMENTS_DELIVERY_METHODS.email
    }
};


export const ConfirmProductPage = (props) => {

    const appEntity = useSelector(state => state.application && state.application.application.legalEntity);
    const applicationId = useSelector(state => state.application && state.application.application.id);
    const additionalProductsList = useSelector(state => state.application && state.application.application.additionalProductsRequired);
    const accountDetails = useSelector(state => state.application && state.application.application.accountDetails);
    const bolProfiles = useSelector(state => state.bol && state.bol.profiles);
    const bolProfileOperators = useSelector(state => state.bol && state.bol.operators);
    const dispatch = useDispatch();


    useEffect(() => {
            dispatch(fetchBolProfiles(appEntity.cif));
        }, []
    );

    const confirmDetails = (accountDetails, additionalProducts, saveAndContinue = false) => {
        const {history} = props;
        let nextPage = saveAndContinue ? '/saveapplication' : newAccountOpeningRoutes.kyc;
        const onProceed = () => history.push(nextPage);
        dispatch(confirmAccount(accountDetails, additionalProducts, applicationId, saveAndContinue, onProceed));
    };


    const onFetchOperators = (profileId) => {
        dispatch(clearBolProfileOperators());
        _.defer(() => profileId && dispatch(fetchBolOperators(profileId)));
    };

    return (
        <ProductDetailsCard
            accountDetails={accountDetails}
            additionalProductsList={additionalProductsList}
            bolProfiles={bolProfiles}
            bolProfileOperators={bolProfileOperators}
            confirmDetails={confirmDetails}
            onFetchOperators={onFetchOperators}
            history={props.history}
        />
    );

}

const ProductDetailsCard = (props) => {

    const _bolProduct = _.find(props.additionalProductsList, product => product.id === ADDITIONAL_PRODUCTS.bolId);
    const _cashManProduct = _.find(props.additionalProductsList, product => product.id === ADDITIONAL_PRODUCTS.cashManId);
    const _accountDetails = props.accountDetails;
    const {bolProfiles, bolProfileOperators, onFetchOperators} = props;
    const defaultBranch = _.find(branches, branch => branch.centreName == 'JOHANNESBURG');
    const filteredBranches = _.filter(branches, b => b.centreName !== defaultBranch.centreName);

    const [errors, setErrors] = useState({});
    const [bolProduct, setBolProduct] = useState(_bolProduct);
    const [cashManProduct, setCashManProduct] = useState(_cashManProduct);
    const [accountDetails, setAccountDetails] = useState(_accountDetails);
    const [additionalProducts, setAdditionalProducts] = useState({
        businessOnline: bolProduct,
        cashManagement: cashManProduct,
        cashManGroupNumber: cashManProduct && cashManProduct.cashManGroupNumber
    });

    const statementTooltip = (
        <Tooltip id="tooltip">
            <strong>Suppress Statement: </strong>
            Select the following option
            if you receive statements
            from Business Online or via Host-to-Host

        </Tooltip>
    );

    const resetError = (attribute) => {
        setErrors(_.extend({}, errors, {[attribute]: null}));
    }

    const validateForm = () => {
        const options = {fullMessages: false};
        const forbiddenDomains = ['gmail.com', 'yahoo.com', 'hotmail.com'];
        const constraints = _.extend(
            {accountName: {presence: true, length: {minimum: 1, message: 'required'}}},
            accountDetails && accountDetails.preferences && accountDetails.preferences.statementDeliveryMethod === STATEMENTS_DELIVERY_METHODS.email ? {
                deliveryDestination: {
                    presence: true, email: true, length: {minimum: 3, message: 'required'},
                    format: function (value, obj) {
                        const valueDomain = value && value.split('@').slice(1)[0];
                        const domain = valueDomain && valueDomain.toLowerCase();
                        return _.find(forbiddenDomains, f => f === domain)
                    }
                }
            } : null
        );

        let errors = validate(accountDetails && accountDetails.preferences, constraints, options);


        if (additionalProducts && additionalProducts.businessOnline || additionalProducts && additionalProducts.cashManagement) {
            const {businessOnline, cashManagement} = additionalProducts;
            const addProductsConstraints = _.extend(
                cashManagement ? {
                    cashManGroupNumber: {
                        presence: true,
                        numericality: true,
                        length: {minimum: 5, maximum: 5, message: 'Required (5 Digit Number)'}
                    }
                } : null
            )

            const bolConstraints = _.extend(businessOnline ? {
                bolProfileId: {
                    presence: true,
                    length: {minimum: 1, message: 'required'}
                },
                transactionalPayments: {
                    presence: true, numericality: {onlyInteger: true, greaterThan: 0}
                },
                transactionalTransfers: {
                    presence: true, numericality: {onlyInteger: true, greaterThan: 0}
                },
                operators: {presence: true}
            } : null);

            const limits = bolProduct && bolProduct.config && bolProduct.config.limits;
            const operators = bolProduct && bolProduct.config && bolProduct.config.operators;
            const bolProfileId = bolProduct && (bolProduct.bolProfileId === OTHER_PROFILE_ID.value) ? null : bolProduct && bolProduct.bolProfileId;
            const bolErrors = validate({...bolProduct, ...limits, operators, bolProfileId}, bolConstraints, options);
            console.log('bolErrors');
            console.log(bolErrors);
            const err = validate(additionalProducts, addProductsConstraints, options);
            errors = _.extend({}, errors, err, bolErrors);
        }
        setErrors(errors);
        return _.isEmpty(errors);
    }

    const saveAndContinue = (event) => {
        saveDetails(event, true);

    }

    const saveDetails = (event, saveAndContinue) => {
        event.preventDefault();

        console.log(bolProduct);

        if (validateForm()) {
            const {additionalProductsList, confirmDetails} = props;

            let updatedAdditionalProductsList = [];
            if (additionalProducts.businessOnline) {
                updatedAdditionalProductsList = _.union(additionalProductsList, [bolProduct])
            }

            if (additionalProducts.cashManagement) {
                updatedAdditionalProductsList = _.union(updatedAdditionalProductsList, [{
                    id: ADDITIONAL_PRODUCTS.cashManId,
                    cashManGroupNumber: additionalProducts.cashManGroupNumber,
                }])
            }
            if (!accountDetails.centreNumber) {
                const defaultBranch = _.find(branches, b => b.centreName === 'JOHANNESBURG');
                accountDetails.centreNumber = defaultBranch.centreNumber;
                accountDetails.branchName = defaultBranch.centreName;
                accountDetails.branchCode = defaultBranch.centreIbt;
            }
            confirmDetails(accountDetails, updatedAdditionalProductsList, saveAndContinue);
        }
    }

    const handleDeliveryMethodChange = ({target}) => {
        const accPreferences = accountDetails && accountDetails.preferences;
        const isPost = target.value === STATEMENTS_DELIVERY_METHODS.post;
        const isSuppress = target.value === STATEMENTS_DELIVERY_METHODS.suppressStatement;

        let preferences = _.extend({}, accPreferences, {statementDeliveryMethod: target.value});

        if (isPost) {
            preferences = _.extend(preferences, {
                statementDeliveryFrequency: FREQUENCY.monthly,
                deliveryDestination: null
            });
        } else if (isSuppress) {
            preferences = _.extend(preferences, {
                statementDeliveryFrequency: null,
                deliveryDestination: null
            });
        } else {
            preferences = _.extend(preferences, {
                statementDeliveryFrequency: FREQUENCY.monthly,
            });
        }

        setAccountDetails(_.extend({}, accountDetails, {preferences}));
    }

    const handleBranchChange = ({target}) => {
        const selectedBranch = _.find(branches, b => b.centreName === target.value);
        const updatedAccount = {
            ...accountDetails,
            centreNumber: selectedBranch.centreNumber,
            branchName: selectedBranch.centreName,
            branchCode: selectedBranch.centreIbt
        }
        setAccountDetails(updatedAccount);
    }

    const handlePrefChange = ({target}, attribute) => {
        const {value} = target;

        const preferences = _.extend({}, accountDetails && accountDetails.preferences, {[attribute]: _.trimStart(value)});
        const updatedAccountDetails = _.extend({}, accountDetails, {preferences});
        setAccountDetails(updatedAccountDetails);
    }

    const onBusOnlineClick = (isSelected) => {
        setAdditionalProducts(_.extend({}, additionalProducts, {businessOnline: isSelected}));
    }

    const onCashManagementClick = (isSelected) => {
        setAdditionalProducts(_.extend({}, additionalProducts, {cashManagement: isSelected}));
    }

    const onAdditionalChange = (e, attribute) => {
        setAdditionalProducts(_.extend({}, additionalProducts, {[attribute]: _.trimStart(e.target.value)}));
    }

    const onChangeBolProduct = (bolProduct) => {
        setBolProduct(bolProduct);
    }

    return (
        <div>
            <form className="page-container">
                <div className="container" style={{minHeight: '50em'}}>
                    <div className="col-xs-12 col-md-6">
                        <div className="card-container-form">
                            <div className="section-title">
                                <span>Product Details</span>
                            </div>

                            <FormField className="form-group" id="accName" error={errors && errors.accountName}>
                                <label htmlFor="accountName">Account Name <small className="text-danger">*</small>
                                </label>

                                <input
                                    className="form-control"
                                    id="accountName"
                                    onChange={(event) => {
                                        errors && errors.accountName && resetError('accountName');
                                        handlePrefChange(event, 'accountName')
                                    }}
                                    maxLength={25}
                                    type="text"
                                    value={accountDetails && accountDetails.preferences && accountDetails.preferences.accountName || ''}
                                />
                            </FormField>

                            <div className="form-group">
                                <label htmlFor="branch">Branch <small className="text-danger">*</small></label>
                                <select
                                    className="form-control"
                                    id="branch"
                                    onChange={(event) => handleBranchChange(event)}
                                    type="text"
                                    value={accountDetails && accountDetails.branchName || ''}
                                >
                                    <option key={`branchCode-default`}>{defaultBranch.centreName}</option>
                                    {
                                        _.map(filteredBranches, (b) => (
                                            <option key={`branchCode-${b.centreNumber}`}>{b.centreName}</option>
                                        ))
                                    }
                                </select>
                            </div>

                            <div className="form-group">
                                <label htmlFor="bankStatementDeliveryMethod">
                                    Bank Statement Delivery Method <small className="text-danger">*</small>&nbsp;
                                    <OverlayTrigger placement="right" overlay={statementTooltip}>
                                        <Glyphicon glyph="question-sign"/>
                                    </OverlayTrigger>
                                </label>
                                <select
                                    className="form-control"
                                    id="statementDeliveryMethod"
                                    onChange={(event) => handleDeliveryMethodChange(event)}
                                    value={accountDetails && accountDetails.preferences && accountDetails.preferences.statementDeliveryMethod || ''}>
                                    <option value={STATEMENTS_DELIVERY_METHODS.email}>Email</option>
                                    <option value={STATEMENTS_DELIVERY_METHODS.post}>Post</option>
                                    <option value={STATEMENTS_DELIVERY_METHODS.suppressStatement}>Suppress Statement
                                    </option>
                                </select>
                            </div>

                            {
                                accountDetails && accountDetails.preferences && accountDetails.preferences.statementDeliveryMethod === STATEMENTS_DELIVERY_METHODS.email &&
                                <FormField className="form-group" id="desti"
                                           error={errors && errors.deliveryDestination}>
                                    <label htmlFor="deliveryDestination">Bank Statement Email Address <small
                                        className="text-danger">*</small></label>
                                    <input
                                        id="deliveryDestination"
                                        className="form-control"
                                        onChange={(event) => {
                                            errors && errors.deliveryDestination && resetError('deliveryDestination');
                                            handlePrefChange(event, 'deliveryDestination')
                                        }}
                                        type="email"
                                        value={accountDetails && accountDetails.preferences && accountDetails.preferences.deliveryDestination || ''}
                                    />
                                </FormField>
                            }

                            {
                                !(accountDetails && accountDetails.preferences && accountDetails.preferences.statementDeliveryMethod === STATEMENTS_DELIVERY_METHODS.suppressStatement) &&

                                <div className="form-group">
                                    <label htmlFor="bankStatementFrequency">Bank Statement Frequency</label>
                                    <select
                                        className="form-control"
                                        id="bankStatementFrequency"
                                        onChange={(event) => handlePrefChange(event, 'statementDeliveryFrequency')}
                                        value={accountDetails && accountDetails.preferences && accountDetails.preferences.statementDeliveryFrequency || ''}
                                    >
                                        <option>{FREQUENCY.monthly}</option>
                                        <option>{FREQUENCY.weekly}</option>
                                        <option>{FREQUENCY.daily}</option>
                                    </select>
                                </div>
                            }
                        </div>
                    </div>
                    <div className="col-xs-12 col-md-6">
                        <div className="card-container-form">
                            <div className="section-title">
                                <span>Add account to the following:</span>
                            </div>
                            <div className="input-group greyText fontSize">
                                <p>Select from the list below if your need you account to be added to them:</p>
                            </div>

                            <div
                                className="inline-container"
                                onClick={() => onBusOnlineClick(!(additionalProducts && additionalProducts.businessOnline))}
                            >
                                <div className="icon-container">
                                    <i className={((additionalProducts && additionalProducts.businessOnline) ? 'fa fa-check-square-o' : 'fa fa-square-o') + ' icon'}
                                       style={{fontSize: 20}}/>
                                </div>
                                Business Online
                            </div>

                            {
                                (additionalProducts && additionalProducts.businessOnline) &&

                                <BolSetup
                                    bolProduct={bolProduct}
                                    bolProfiles={bolProfiles}
                                    bolProfileOperators={bolProfileOperators}
                                    errors={errors}
                                    onFetchOperators={onFetchOperators}
                                    onChange={onChangeBolProduct}
                                    resetErrors={resetError}
                                />
                            }
                            <hr/>

                            <div className="form-group">

                                <div
                                    className="inline-container"
                                    onClick={() => onCashManagementClick(!(additionalProducts && additionalProducts.cashManagement))}
                                >
                                    <div className="icon-container">
                                        <i className={((additionalProducts && additionalProducts.cashManagement) ? 'fa fa-check-square-o' : 'fa fa-square-o') + ' icon'}
                                           style={{fontSize: 20}}/>
                                    </div>
                                    Cash Management
                                </div>
                                {
                                    additionalProducts && additionalProducts.cashManagement &&
                                    <div>
                                        <br/>
                                        <FormField className="form-group" id="cashman"
                                                   error={errors && errors.cashManGroupNumber}>
                                            <label>Cashman Group Number</label>

                                            <input
                                                className="form-control"
                                                id="cashManGroupNumber"
                                                maxLength={5}
                                                onChange={(event) => {
                                                    errors && errors.cashManGroupNumber && resetError('cashManGroupNumber');
                                                    onAdditionalChange(event, 'cashManGroupNumber');
                                                }}
                                                type="number"
                                                value={additionalProducts && additionalProducts.cashManGroupNumber || ''}
                                            />
                                        </FormField>
                                    </div>
                                }
                                <hr/>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="page-footer-section">
                    <ButtonsComponent
                        history={props.history}
                        onNext={saveDetails}
                        onSaveAndContinue={saveAndContinue}
                        prevPage={newAccountOpeningRoutes.confirmdetails}
                    />
                </div>
            </form>
        </div>
    );
}

export default ConfirmProductPage;
